"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1704],{

/***/ 81704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Product": function() { return /* binding */ Product; },
  "default": function() { return /* binding */ services_Product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./helpers/withSentryAssertion.ts
var withSentryAssertion = __webpack_require__(32237);
// EXTERNAL MODULE: ./node_modules/@recoiljs/refine/es/index.js
var es = __webpack_require__(30901);
;// CONCATENATED MODULE: ./types/SearchAPI/SAPIProduct.ts


var Booleanish = (0,es.or)((0,es.union)((0,es.literal)("True"), (0,es.literal)("true"), (0,es.literal)("false"), (0,es.literal)("False")), (0,es.bool)());
var SAPIProductOptionValue = (0,es.object)({
    option_display_name: (0,es.string)(),
    option_id: (0,es.number)(),
    id: (0,es.number)(),
    label: (0,es.string)()
});
var SAPIProductVariant = (0,es.object)({
    images: (0,es.array)((0,es.object)({
        url_thumbnail: (0,es.string)(),
        url_square: (0,es.string)(),
        url_standard: (0,es.string)(),
        url_zoom: (0,es.string)()
    })),
    calculated_price: (0,es.number)(),
    option_values: (0,es.array)(SAPIProductOptionValue),
    // upc: string(),
    colorChips: (0,es.array)((0,es.string)()),
    sale_price: (0,es.number)(),
    inventory_level: (0,es.number)(),
    price: (0,es.number)(),
    product_id: (0,es.number)(),
    lead_time: (0,es.optional)((0,es.number)()),
    name: (0,es.string)(),
    purchasing_disabled: (0,es.bool)(),
    id: (0,es.number)(),
    sku: (0,es.string)()
});
var SAPIProductOption = (0,es.object)({
    product_id: (0,es.number)(),
    option_values: (0,es.array)(SAPIProductOptionValue),
    name: (0,es.string)(),
    id: (0,es.number)(),
    display_name: (0,es.string)(),
    type: (0,es.string)(),
    sort_order: (0,es.number)()
});
var SAPIProductWarrantyVariantImage = (0,es.object)({
    url: (0,es.string)()
});
var SAPIProductWarrantyVariant = (0,es.object)({
    application_type: (0,es.optional)((0,es.string)()),
    inventoryType: (0,es.optional)((0,es.number)()),
    inventoryLevel: (0,es.optional)((0,es.number)()),
    baseDateForDeliveryCalculation: (0,es.optional)((0,es.nullable)((0,es.string)())),
    materials: (0,es.optional)((0,es.string)()),
    arm_height: (0,es.optional)((0,es.string)()),
    art_quality: (0,es.optional)((0,es.string)()),
    artist_commission: (0,es.optional)((0,es.string)()),
    artist_id: (0,es.optional)((0,es.string)()),
    artist: (0,es.optional)((0,es.string)()),
    assembly_required: (0,es.optional)((0,es.bool)()),
    authors: (0,es.optional)((0,es.string)()),
    backplate_dimensions: (0,es.optional)((0,es.string)()),
    base_dimensions: (0,es.optional)((0,es.string)()),
    bed_clearance_height: (0,es.optional)((0,es.string)()),
    bed_footboard_dims: (0,es.optional)((0,es.string)()),
    bed_size: (0,es.optional)((0,es.string)()),
    bedding_size: (0,es.optional)((0,es.string)()),
    bedrails_dims: (0,es.optional)((0,es.string)()),
    blend_material_percentage: (0,es.optional)((0,es.string)()),
    book_type: (0,es.optional)((0,es.string)()),
    bulb_included: (0,es.optional)((0,es.string)()),
    bulb_type: (0,es.optional)((0,es.string)()),
    bulb_watts: (0,es.optional)((0,es.string)()),
    burn_time: (0,es.optional)((0,es.string)()),
    canopy_dimensions: (0,es.optional)((0,es.string)()),
    capacity: (0,es.optional)((0,es.string)()),
    care: (0,es.optional)((0,es.string)()),
    case_pk_qty: (0,es.optional)((0,es.number)()),
    chain_length: (0,es.optional)((0,es.string)()),
    clearance_height: (0,es.optional)((0,es.string)()),
    closure_type: (0,es.optional)((0,es.string)()),
    color_family: (0,es.optional)((0,es.string)()),
    comfort_level: (0,es.optional)((0,es.string)()),
    condition: (0,es.optional)((0,es.string)()),
    construction: (0,es.optional)((0,es.string)()),
    contemporary_original: (0,es.optional)((0,es.string)()),
    contract_grade: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    cord_length: (0,es.optional)((0,es.string)()),
    damage: (0,es.optional)((0,es.string)()),
    details: (0,es.optional)((0,es.string)()),
    dimensions_uom: (0,es.optional)((0,es.string)()),
    dimensions: (0,es.optional)((0,es.string)()),
    distance_between_arms: (0,es.optional)((0,es.string)()),
    era: (0,es.optional)((0,es.string)()),
    estimated_max_delivery_days: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.number)())),
    estimated_min_delivery_days: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.number)())),
    evergreen: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.number)())),
    exclusive: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.number)())),
    fill: (0,es.optional)((0,es.string)()),
    fixture_frame_dims: (0,es.optional)((0,es.string)()),
    floral_type: (0,es.optional)((0,es.string)()),
    frame_color: (0,es.optional)((0,es.string)()),
    frame_details: (0,es.optional)((0,es.string)()),
    frame_materials: (0,es.optional)((0,es.string)()),
    framed: (0,es.optional)((0,es.bool)()),
    fulfillment_method: (0,es.optional)((0,es.string)()),
    full_cost: (0,es.optional)((0,es.number)()),
    gtin: (0,es.optional)((0,es.nullable)((0,es.number)())),
    handmade_machinemade: (0,es.optional)((0,es.string)()),
    hardware_color: (0,es.optional)((0,es.string)()),
    hardware_material: (0,es.optional)((0,es.string)()),
    hardwired: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    hidden_zipper: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    images: (0,es.optional)((0,es.array)(SAPIProductWarrantyVariantImage)),
    imprint: (0,es.optional)((0,es.string)()),
    includes: (0,es.optional)((0,es.string)()),
    ingredients: (0,es.optional)((0,es.string)()),
    is_entryway: (0,es.optional)((0,es.bool)()),
    is_free_shipping: (0,es.optional)((0,es.bool)()),
    is_returnable: (0,es.optional)((0,es.bool)()),
    is_vintage: (0,es.optional)((0,es.bool)()),
    is_white_glove: (0,es.optional)((0,es.bool)()),
    isbn: (0,es.optional)((0,es.string)()),
    // lead_time: optional(number()),
    leg_height: (0,es.optional)((0,es.string)()),
    legacy_variant_id: (0,es.optional)((0,es.number)()),
    made_in: (0,es.optional)((0,es.string)()),
    made_to_order: (0,es.optional)((0,es.string)()),
    map_price: (0,es.optional)((0,es.nullable)((0,es.number)())),
    mat_board_color: (0,es.optional)((0,es.string)()),
    mat_board_material: (0,es.optional)((0,es.string)()),
    mat_board_options: (0,es.optional)((0,es.string)()),
    mat_board_width: (0,es.optional)((0,es.string)()),
    material_family: (0,es.optional)((0,es.string)()),
    medium: (0,es.optional)((0,es.string)()),
    number_of_boxes: (0,es.optional)((0,es.union)((0,es.number)(), (0,es.string)())),
    number_of_rolls: (0,es.optional)((0,es.string)()),
    outdoor: (0,es.optional)(Booleanish),
    package_height: (0,es.optional)((0,es.string)()),
    package_length: (0,es.optional)((0,es.string)()),
    package_weight: (0,es.optional)((0,es.string)()),
    package_width: (0,es.optional)((0,es.string)()),
    packaging_type: (0,es.optional)((0,es.string)()),
    page_count: (0,es.optional)((0,es.string)()),
    pattern_direction: (0,es.optional)((0,es.string)()),
    pattern: (0,es.optional)((0,es.string)()),
    performance_fabric: (0,es.optional)(Booleanish),
    period: (0,es.optional)((0,es.string)()),
    pile_height: (0,es.optional)((0,es.string)()),
    pillowcase_size: (0,es.optional)((0,es.string)()),
    please_note: (0,es.optional)((0,es.string)()),
    primary_color_hex: (0,es.optional)((0,es.string)()),
    primary_color: (0,es.optional)((0,es.string)()),
    primary_finish: (0,es.optional)((0,es.string)()),
    primary_letter: (0,es.optional)((0,es.string)()),
    primary_material: (0,es.optional)((0,es.string)()),
    primary_size: (0,es.optional)((0,es.string)()),
    prop_65_compliant: (0,es.optional)((0,es.string)()),
    quantity_on_hand: (0,es.optional)((0,es.nullable)((0,es.number)())),
    removable_cushions: (0,es.optional)(Booleanish),
    removable_legs: (0,es.optional)(Booleanish),
    reversible_cushions: (0,es.optional)(Booleanish),
    rod_length: (0,es.optional)((0,es.string)()),
    rug_pad_recommended: (0,es.optional)((0,es.string)()),
    rug_size: (0,es.optional)((0,es.string)()),
    scent_life: (0,es.optional)((0,es.string)()),
    scent: (0,es.optional)((0,es.string)()),
    seat_depth: (0,es.optional)((0,es.string)()),
    seat_height: (0,es.optional)((0,es.string)()),
    secondary_color_hex: (0,es.optional)((0,es.string)()),
    secondary_color: (0,es.optional)((0,es.string)()),
    shade_dims: (0,es.optional)((0,es.string)()),
    shade_finish: (0,es.optional)((0,es.string)()),
    shade_material: (0,es.optional)((0,es.string)()),
    size_family: (0,es.optional)((0,es.string)()),
    sloped_ceiling: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    special_care: (0,es.optional)((0,es.string)()),
    square_footage_per_roll: (0,es.optional)((0,es.string)()),
    style: (0,es.optional)((0,es.string)()),
    subject_matter: (0,es.optional)((0,es.string)()),
    substrate_type: (0,es.optional)((0,es.string)()),
    switch_type: (0,es.optional)((0,es.string)()),
    thread_count: (0,es.optional)((0,es.string)()),
    // upc: optional(nullable(number())),
    upholstery_color: (0,es.optional)((0,es.string)()),
    upholstery_construction: (0,es.optional)((0,es.string)()),
    upholstery_material: (0,es.optional)((0,es.string)()),
    variant_type: (0,es.optional)((0,es.string)()),
    vendor_quantity: (0,es.optional)((0,es.nullable)((0,es.number)())),
    vendor_sku: (0,es.optional)((0,es.string)()),
    wallpaper_application: (0,es.optional)((0,es.string)()),
    wallpaper_pattern_scale: (0,es.optional)((0,es.string)()),
    wallpaper_removal: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    wallpaper_repeat: (0,es.optional)((0,es.string)()),
    weight_uom: (0,es.optional)((0,es.string)()),
    weight: (0,es.optional)((0,es.string)()),
    wet_rated: (0,es.optional)((0,es.union)((0,es.string)(), (0,es.bool)())),
    wood_type: (0,es.optional)((0,es.string)())
});
var SAPIProductWarrantyVariants = (0,es.dict)(SAPIProductWarrantyVariant);
var SAPIProductWarranty = (0,es.object)({
    variants: SAPIProductWarrantyVariants,
    attributes: (0,es.optional)((0,es.voidable)((0,es.array)((0,es.object)({
        id: (0,es.number)(),
        name: (0,es.string)(),
        value: (0,es.array)((0,es.string)())
    })))),
    additional: (0,es.object)({
        brand_code: (0,es.optional)((0,es.string)()),
        colors: (0,es.optional)((0,es.string)()),
        created_date: (0,es.optional)((0,es.string)()),
        finishes: (0,es.optional)((0,es.string)()),
        ingestion_id: (0,es.optional)((0,es.number)()),
        is_digital: (0,es.optional)((0,es.bool)()),
        legacy_product_id: (0,es.optional)((0,es.string)()),
        // listrak_master_sku: string(),
        // master_vendor_id: optional(string()),
        materials: (0,es.optional)((0,es.string)()),
        modified_date: (0,es.optional)((0,es.string)()),
        planning_hierarchy: (0,es.optional)((0,es.array)((0,es.string)())),
        primary_category_breadcrumb: (0,es.optional)((0,es.string)()),
        primary_variant_sku: (0,es.optional)((0,es.union)((0,es.number)(), (0,es.string)())),
        sizes: (0,es.optional)((0,es.string)()),
        vendor_code: (0,es.optional)((0,es.union)((0,es.number)(), (0,es.string)())),
        vendor_name: (0,es.optional)((0,es.string)())
    })
});
var SAPIProductAdditionalInfo = (0,es.object)({
    artist_name: (0,es.optional)((0,es.string)()),
    is_artisanal: (0,es.optional)(Booleanish),
    "Facet Color Family": (0,es.optional)((0,es.tuple)((0,es.string)())),
    "Made of": (0,es.optional)((0,es.tuple)((0,es.string)())),
    "Frame details": (0,es.optional)((0,es.tuple)((0,es.string)())),
    Dimensions: (0,es.optional)((0,es.tuple)((0,es.string)())),
    Finish: (0,es.optional)((0,es.tuple)((0,es.string)())),
    is_vmf: (0,es.optional)((0,es.tuple)((0,es.string)())),
    uom: (0,es.optional)((0,es.tuple)((0,es.string)())),
    "Product Code": (0,es.optional)((0,es.tuple)((0,es.string)())),
    "Master Vendor Id": (0,es.optional)((0,es.tuple)((0,es.string)())),
    free_shipping: (0,es.optional)((0,es.tuple)((0,es.string)())),
    price_range: (0,es.optional)((0,es.tuple)((0,es.string)())),
    sale: (0,es.optional)((0,es.tuple)((0,es.string)())),
    created_date: (0,es.optional)((0,es.string)()),
    modified_date: (0,es.optional)((0,es.string)()),
    ingestion_id: (0,es.optional)((0,es.number)()),
    // listrak_master_sku: optional(string()),
    legacy_product_id: (0,es.optional)((0,es.string)()),
    brand_code: (0,es.optional)((0,es.string)()),
    // master_vendor_id: optional(string()),
    primary_category_breadcrumb: (0,es.optional)((0,es.string)()),
    colors: (0,es.optional)((0,es.string)()),
    materials: (0,es.optional)((0,es.string)()),
    finishes: (0,es.optional)((0,es.string)()),
    sizes: (0,es.optional)((0,es.string)()),
    is_digital: (0,es.optional)((0,es.bool)()),
    vendor_code: (0,es.optional)((0,es.or)((0,es.string)(), (0,es.number)())),
    "Brand Code": (0,es.optional)((0,es.string)()),
    number_of_boxes: (0,es.optional)((0,es.string)()),
    dimensions_uom: (0,es.optional)((0,es.string)()),
    estimated_max_delivery_days: (0,es.optional)((0,es.string)()),
    is_entryway: (0,es.optional)(Booleanish),
    // lead_time: optional(string()),
    exclusive: (0,es.optional)((0,es.string)()),
    is_free_shipping: (0,es.optional)(Booleanish),
    "Primary Category Breadcrumb": (0,es.optional)((0,es.string)()),
    is_white_glove: (0,es.optional)(Booleanish),
    made_to_order: (0,es.optional)((0,es.string)()),
    is_vintage: (0,es.optional)(Booleanish),
    "Vendor Code": (0,es.optional)((0,es.string)()),
    primary_variant_sku: (0,es.optional)((0,es.number)()),
    estimated_min_delivery_days: (0,es.optional)((0,es.string)()),
    care: (0,es.optional)((0,es.string)()),
    style: (0,es.optional)((0,es.string)()),
    performance_fabric: (0,es.optional)(Booleanish),
    period: (0,es.optional)((0,es.string)())
});
var SAPIProductBreadCrumb = (0,es.object)({
    path: (0,es.string)(),
    parent_id: (0,es.number)(),
    name: (0,es.string)(),
    id: (0,es.number)(),
    url: (0,es.string)()
});
var SAPIProductPrice = (0,es.object)({
    calculated_price: (0,es.number)(),
    price: (0,es.number)(),
    sale_price: (0,es.number)(),
    variants: (0,es.array)((0,es.object)({
        sku: (0,es.string)(),
        calculated_price: (0,es.number)(),
        price: (0,es.number)(),
        id: (0,es.number)(),
        sale_price: (0,es.number)()
    }))
});
var SAPIProduct = (0,es.object)({
    calculated_price: (0,es.number)(),
    // gift_wrapping_options_list: array(unknow),
    page_title: (0,es.string)(),
    is_condition_shown: (0,es.bool)(),
    variants: (0,es.array)(SAPIProductVariant),
    type: (0,es.string)(),
    map_price: (0,es.number)(),
    retail_price: (0,es.number)(),
    layout_file: (0,es.string)(),
    price: (0,es.number)(),
    inventory_warning_level: (0,es.number)(),
    options: (0,es.array)((0,es.object)({
        product_id: (0,es.number)(),
        option_values: (0,es.array)((0,es.object)({
            id: (0,es.number)(),
            label: (0,es.string)(),
            value_data: (0,es.nullable)((0,es.or)((0,es.string)(), (0,es.number)())),
            is_default: (0,es.bool)(),
            sort_order: (0,es.number)()
        })),
        name: (0,es.string)(),
        id: (0,es.number)(),
        display_name: (0,es.string)(),
        type: (0,es.string)(),
        sort_order: (0,es.number)()
    })),
    warranty: SAPIProductWarranty,
    is_free_shipping: (0,es.bool)(),
    id: (0,es.number)(),
    total_sold: (0,es.number)(),
    sku: (0,es.string)(),
    brand: (0,es.nullable)((0,es.string)()),
    height: (0,es.number)(),
    custom_url: (0,es.object)({
        is_customized: (0,es.bool)(),
        url: (0,es.string)()
    }),
    open_graph_use_meta_description: (0,es.bool)(),
    weight: (0,es.number)(),
    // upc: string(),
    mpn: (0,es.string)(),
    open_graph_type: (0,es.string)(),
    open_graph_use_image: (0,es.bool)(),
    brand_id: (0,es.number)(),
    meta_description: (0,es.string)(),
    condition: (0,es.string)(),
    inventory_level: (0,es.number)(),
    // additional_info: SAPIProductAdditionalInfo,
    name: (0,es.string)(),
    open_graph_description: (0,es.string)(),
    open_graph_use_product_name: (0,es.bool)(),
    reviews_rating_sum: (0,es.number)(),
    breadcrumbs: (0,es.array)(SAPIProductBreadCrumb),
    reviews_count: (0,es.number)(),
    brand_code: (0,es.optional)((0,es.string)()),
    bestSellingScore: (0,es.number)(),
    inventory_tracking: (0,es.string)(),
    // preorder_release_date: nullable(bool()),
    description: (0,es.string)(),
    bin_picking_number: (0,es.string)(),
    colorChips: (0,es.array)((0,es.object)({
        sku: (0,es.string)(),
        colors: (0,es.array)((0,es.string)())
    })),
    availability: (0,es.string)(),
    search_keywords: (0,es.string)(),
    meta_keywords: (0,es.array)((0,es.string)()),
    related_products: (0,es.array)((0,es.number)()),
    is_price_hidden: (0,es.bool)(),
    order_quantity_minimum: (0,es.number)(),
    availability_description: (0,es.string)(),
    fixed_cost_shipping_price: (0,es.number)(),
    categories: (0,es.array)((0,es.number)()),
    base_variant_id: (0,es.nullable)((0,es.number)()),
    prices: SAPIProductPrice,
    sort_order: (0,es.number)(),
    cost_price: (0,es.number)(),
    option_set_display: (0,es.string)(),
    gtin: (0,es.string)(),
    order_quantity_maximum: (0,es.number)(),
    category_info: (0,es.array)((0,es.object)({
        path: (0,es.string)(),
        parent_id: (0,es.number)(),
        name: (0,es.string)(),
        id: (0,es.number)(),
        url: (0,es.string)()
    })),
    is_visible: (0,es.bool)(),
    is_preorder_only: (0,es.bool)(),
    date_created: (0,es.string)(),
    preorder_message: (0,es.string)(),
    // master_vendor_id: string(),
    tax_class_id: (0,es.number)(),
    open_graph_title: (0,es.string)(),
    isNew: (0,es.bool)(),
    sale_price: (0,es.number)(),
    product_tax_code: (0,es.string)(),
    depth: (0,es.number)(),
    max_price: (0,es.number)(),
    date_modified: (0,es.string)(),
    min_price: (0,es.number)(),
    is_on_sale: (0,es.bool)(),
    gift_wrapping_options_type: (0,es.string)(),
    width: (0,es.number)(),
    readyToShip: (0,es.bool)(),
    price_hidden_label: (0,es.string)(),
    is_featured: (0,es.bool)(),
    view_count: (0,es.number)(),
    reviewRating: (0,es.optional)((0,es.number)()),
    reviewCount: (0,es.optional)((0,es.number)())
});
var SAPIProducts = (0,es.array)(SAPIProduct);
var assertSAPIProduct = (0,withSentryAssertion/* withSentryAssertion */.o)([
    SAPIProduct,
    "Search API Product"
]);
var assertSAPIProducts = (0,withSentryAssertion/* withSentryAssertion */.o)([
    SAPIProducts,
    "Search API Products Array"
]);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./services/CacheService.ts



var MAX_FIFO_QUEUE_SIZE = 50;
var ClientSideGlobalFifoCacheStorage = {};
var ClientSideGlobalCacheSpaceIndex = 0;
var FifoStorage = [];
var AppendGlobalCache = function(param) {
    var key = param.key, space = param.space, value = param.value;
    ClientSideGlobalFifoCacheStorage[space] = ClientSideGlobalFifoCacheStorage[space] || {};
    ClientSideGlobalFifoCacheStorage[space][key] = value;
    FifoStorage.push({
        space: space,
        key: key
    });
    if (FifoStorage.length > MAX_FIFO_QUEUE_SIZE) {
        var removable = FifoStorage.shift();
        if (removable && !(removable.space === space && removable.key === key)) {
            delete ClientSideGlobalFifoCacheStorage[removable.space][removable.key];
        }
    }
};
var GlobalCacheContains = function(param) {
    var key = param.key, space = param.space;
    return !!Object.getOwnPropertyDescriptor(ClientSideGlobalFifoCacheStorage, space) && !!Object.getOwnPropertyDescriptor(ClientSideGlobalFifoCacheStorage[space], key);
};
var GlobalCacheAccess = function(param) {
    var key = param.key, space = param.space;
    var ref;
    return ClientSideGlobalFifoCacheStorage === null || ClientSideGlobalFifoCacheStorage === void 0 ? void 0 : (ref = ClientSideGlobalFifoCacheStorage[space]) === null || ref === void 0 ? void 0 : ref[key];
};
var ClientSideCache = function(computation) {
    return function(functor) {
        if (false) {}
        var space = ClientSideGlobalCacheSpaceIndex;
        ClientSideGlobalCacheSpaceIndex += 1;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _len, args, _key, key, value, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        for(_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _args[_key];
                        }
                        key = computation.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
                        if (!GlobalCacheContains({
                            space: space,
                            key: key
                        })) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.t0 = GlobalCacheAccess({
                            space: space,
                            key: key
                        });
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.next = 8;
                        return functor.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
                    case 8:
                        _ctx.t0 = _ctx.sent;
                    case 9:
                        value = _ctx.t0;
                        AppendGlobalCache({
                            space: space,
                            key: key,
                            value: value
                        });
                        return _ctx.abrupt("return", GlobalCacheAccess({
                            key: key,
                            space: space
                        }));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
};

// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
;// CONCATENATED MODULE: ./services/Product.ts








var CacheBySku = ClientSideCache(function(param) {
    var sku = param.sku;
    return sku;
});
var CacheBySkus = ClientSideCache(function(skus) {
    return skus.sort().join(",");
});
var getProductBySkus = CacheBySkus(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(skus) {
        var ref, ref1, Axios, products;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 3;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 9669).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23))
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    Axios = ref1.default;
                    _ctx.next = 9;
                    return Axios.get("".concat(Configuration.SEARCH_API, "/product"), {
                        params: {
                            skus: skus.join(",")
                        }
                    });
                case 9:
                    _ctx.t2 = _ctx.sent.data;
                    if (_ctx.t2) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.t2 = [];
                case 12:
                    products = _ctx.t2;
                    if (products) {
                        try {
                            assertSAPIProducts(products);
                        } catch (e) {
                            (0,Log/* log */.cM)(e);
                        }
                    }
                    return _ctx.abrupt("return", products);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(skus) {
        return _ref.apply(this, arguments);
    };
}());
var getProductBySku = CacheBySku(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var sku, ref, product;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sku = param.sku;
                    ;
                    (0,Log/* log */.cM)("Product.bySku sku: ".concat(sku), {
                        sku: sku
                    });
                    _ctx.next = 5;
                    return getProductBySkus([
                        sku
                    ]);
                case 5:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 9:
                    if (!_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 14;
                    break;
                case 13:
                    _ctx.t2 = ref[0];
                case 14:
                    product = _ctx.t2;
                    if (product) {
                        try {
                            assertSAPIProduct(product);
                        } catch (e) {
                            (0,Log/* log */.cM)(e);
                        }
                    }
                    return _ctx.abrupt("return", product);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var Product = {
    bySkus: getProductBySkus,
    bySku: getProductBySku
};
/* harmony default export */ var services_Product = (Product);


/***/ })

}]);